// extracted by mini-css-extract-plugin
export default {"mCard":"WC-z","image":"XC-z","imageNoBackground":"YC-z","imageHasCategory":"ZC-z","fullWidth":"_C-z"};